/* RAKNIDA · assets/rk-trade-page.js
   Trade Program interactions ported from the v10 prototype:
   compact tab bar on scroll-up, floating apply CTA, Reference tab switch,
   FAQ + Terms accordions, tier comparison table, mobile tap-to-expand cards,
   and the email hand-off to /pages/trade-apply.
   Idempotent: safe to re-run on shopify:section:load in the Theme Editor. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 900px)';

  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  /* ── Reference tabs (Questions / Terms) ── */
  function initRefTabs(root) {
    var tabs = root.querySelectorAll('[data-rk-tp-ref-tab]');
    if (!tabs.length) return;
    each(tabs, function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-rk-tp-ref-tab');
        each(tabs, function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        each(root.querySelectorAll('[data-rk-tp-ref-pane]'), function (pane) {
          pane.hidden = pane.getAttribute('data-rk-tp-ref-pane') !== key;
        });
      });
    });
  }

  /* ── Single-open accordions (FAQ + Terms) ── */
  function initAccordion(root, group) {
    var buttons = root.querySelectorAll('[data-rk-tp-acc="' + group + '"]');
    if (!buttons.length) return;
    each(buttons, function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var wasOpen = btn.getAttribute('aria-expanded') === 'true';
        each(buttons, function (other) {
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          other.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });
        if (!wasOpen) {
          btn.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
        }
      });
    });
  }

  /* ── Tier comparison table ── */
  function initCompare(root) {
    each(root.querySelectorAll('[data-rk-tp-compare]'), function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var glyph = btn.querySelector('.rk-tp-compare-glyph');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
        if (glyph) glyph.textContent = open ? '+' : '\u2212';
      });
    });
  }

  /* ── Mobile tap-to-expand cards (services, qualifies, difference) ── */
  function initExpanders(root) {
    var cards = root.querySelectorAll('[data-rk-tp-exp]');
    if (!cards.length) return;
    var mq = window.matchMedia(MOBILE);

    function setCard(card, expanded) {
      var toggle = card.querySelector('.rk-tp-exp-toggle');
      if (expanded) card.classList.remove('is-collapsed');
      else card.classList.add('is-collapsed');
      if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function sync() {
      each(cards, function (card) {
        setCard(card, !mq.matches);
      });
    }

    each(cards, function (card) {
      card.addEventListener('click', function (e) {
        if (!mq.matches) return;
        if (e.target.closest('a')) return;
        setCard(card, card.classList.contains('is-collapsed'));
      });
      var toggle = card.querySelector('.rk-tp-exp-toggle');
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!mq.matches) return;
          setCard(card, card.classList.contains('is-collapsed'));
        });
      }
    });

    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }

  /* ── Email hand-off: carry the typed address into the application URL ── */
  function initApplyHandoff(root) {
    var input = root.querySelector('[data-rk-tp-apply-email]');
    var link = root.querySelector('[data-rk-tp-apply-link]');
    if (!input || !link) return;
    var base = link.getAttribute('data-rk-tp-apply-link') || link.getAttribute('href') || '';

    function update() {
      var value = (input.value || '').trim();
      if (value.indexOf('@') > 0) {
        link.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'email=' + encodeURIComponent(value));
      } else {
        link.setAttribute('href', base);
      }
    }
    input.addEventListener('input', update);
    input.addEventListener('change', update);
    update();
  }

  /* ── Compact tab bar: reveals on scroll-up past the hero ── */
  function initStickyTabs(root) {
    var bar = root.querySelector('[data-rk-tp-sticky-tabs]');
    if (!bar) return;
    var last = window.scrollY;
    function onScroll() {
      var y = window.scrollY;
      var show = y > 620 && y < last - 4;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      each(bar.querySelectorAll('a'), function (a) {
        a.setAttribute('tabindex', show ? '0' : '-1');
      });
      last = y;
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Floating Apply CTA: show after 500px; hide near #rk-tp-apply (prototype) ── */
  function initFloat(root) {
    var float =
      (root && root.querySelector('[data-rk-tp-float]')) ||
      (root && root.parentElement && root.parentElement.querySelector('[data-rk-tp-float]')) ||
      document.querySelector('[data-rk-tp-float]');
    if (!float) return;
    /* Theme Editor: keep the float off so it can't steal block clicks */
    if (window.Shopify && Shopify.designMode) {
      float.classList.remove('is-on');
      return;
    }
    /* Reparent to <body> so theme chrome / promo overflow:hidden never traps fixed. */
    if (float.parentElement !== document.body) {
      document.body.appendChild(float);
    }
    function onScroll() {
      var target = document.getElementById('rk-tp-apply');
      var top = target ? target.getBoundingClientRect().top : 99999;
      var y = window.scrollY || window.pageYOffset || 0;
      float.classList.toggle('is-on', y > 500 && top > 420);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* Theme Editor: don't navigate / smooth-scroll — let block selection win. */
  function initDesignModeGuards() {
    if (!(window.Shopify && Shopify.designMode)) return;
    if (document.documentElement.dataset.rkTpEdGuard === '1') return;
    document.documentElement.dataset.rkTpEdGuard = '1';
    document.addEventListener('click', function (e) {
      /* Shop hover chrome (QV / ATC / wishlist) — block so editor selects the tile. */
      var action = e.target.closest && e.target.closest('.rk-tp [data-rk-qv], .rk-tp [data-rk-add-cart], .rk-tp .rk-pc-wish');
      if (action) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var a = e.target.closest && e.target.closest('.rk-tp a[href]');
      if (!a) return;
      e.preventDefault();
    }, true);
  }

  /* ── Smooth in-page anchors (See pricing tiers, Apply, Reference, …)
     Works across both Trade sections — button may live in part 1 while
     #rk-tp-tiers lives in part 2. Idempotent on the document. ── */
  function initSmoothAnchors() {
    if (window.Shopify && Shopify.designMode) return;
    if (document.documentElement.dataset.rkTpSmooth === '1') return;
    document.documentElement.dataset.rkTpSmooth = '1';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function targetFromHref(href) {
      if (!href) return null;
      var hashIdx = href.indexOf('#');
      if (hashIdx < 0) return null;
      var id = href.slice(hashIdx + 1).split('?')[0].split('&')[0];
      if (!id) return null;
      if (hashIdx > 0) {
        try {
          var url = new URL(href, window.location.href);
          if (url.pathname !== window.location.pathname) return null;
        } catch (err) {
          return null;
        }
      }
      return document.getElementById(id);
    }

    function scrollToEl(el, id) {
      if (!el) return;
      el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (id && history && history.pushState) {
        try { history.pushState(null, '', '#' + id); } catch (err) { /* ignore */ }
      }
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('#') < 0) return;
      var el = targetFromHref(href);
      if (!el) return;
      /* Only handle Trade-page anchors / links inside .rk-tp */
      var inTrade = a.closest('.rk-tp') || el.closest('.rk-tp') || (el.id && el.id.indexOf('rk-tp-') === 0);
      if (!inTrade) return;
      e.preventDefault();
      scrollToEl(el, el.id);
    });

    function scrollHash() {
      var id = (window.location.hash || '').replace(/^#/, '');
      if (!id) return;
      var el = document.getElementById(id);
      if (!el || !el.closest('.rk-tp')) return;
      /* Defer so layout/header height are settled */
      window.requestAnimationFrame(function () {
        scrollToEl(el, null);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollHash);
    } else {
      scrollHash();
    }
  }

  function init(root) {
    if (!root || root.dataset.rkTpReady === '1') return;
    root.dataset.rkTpReady = '1';
    /* Theme Editor: skip interactive chrome so FAQ/steps/tabs/compare
       receive editor selection instead of toggling UI. */
    if (window.Shopify && Shopify.designMode) {
      initFloat(root);
      return;
    }
    initRefTabs(root);
    initAccordion(root, 'faq');
    initAccordion(root, 'terms');
    initCompare(root);
    initExpanders(root);
    initApplyHandoff(root);
    initStickyTabs(root);
    initFloat(root);
  }

  function initAll(scope) {
    initDesignModeGuards();
    initSmoothAnchors();
    each((scope || document).querySelectorAll('.rk-tp'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
